<template>
  <div class="inner-box">
    <el-form size="mini" :model="form" ref="catInfoForm" class="components">
      <el-row>
        <el-col>
          <el-col :span="6">
            <el-form-item label="의뢰번호">
              <el-input v-model="form.requestId" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="의뢰일자">
              <el-date-picker type="date" placeholder="Pick a date" v-model="form.requestDt" style="width: 100%;" value-format="yyyy-MM-dd" ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="의뢰자">
              <el-input v-model="form.requestNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="설치완료요청일">
              <el-date-picker type="date" placeholder="Pick a date" v-model="form.requestSetupDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-col :span="4">
            <el-form-item label="고객구분">
              <div style="display: flex; width: 100%">
                <el-input v-model="form.siteTypeNm" style="width: 70%"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="searchSite"/>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="사이트명">
              <el-row>
                <el-col :span="24">
                  <el-col :span="8">
                    <el-input type="text" v-model="form.siteNm1" disabled></el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input type="text" v-model="form.siteNm2" disabled></el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input type="text" v-model="form.siteNm3" disabled></el-input>
                  </el-col>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="4">
            <el-form-item label="주소">
              <div style="display: flex; width: 100%">
                <el-input v-model="form.zipCd" disabled style="width: 70%"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-input v-model="form.addr1" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-input v-model="form.addr2" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="8">
            <el-form-item label="고객명">
              <el-input v-model="form.chargeNm" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="전화번호">
              <el-input v-model="form.telNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="휴대폰">
              <el-input v-model="form.hpNo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row class="demo-autocomplete" >
        <el-col :span="24">
          <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5}"
              placeholder="유의사항을 작성하세요."
              v-model="form.memo">
          </el-input>
          <div class="grid-content bg-purple"></div>
        </el-col>
      </el-row>
    </el-form>

    <div class="table-area" style="width: 100%; display: flex;">
      <div class="table-b" style="width: 48%; margin-right: 30px;">
        <div class="table-header">
          <div class="table-name">
            <h3 class="ico_table_name">{{ `설치모델` }}</h3>
          </div>
          <div class="btn-wrap btn-type1 clearfix">
            <button class="btn-size btn-gray fl_left" @click="openModel()">
            <span class="btn-icon">
              <i class="fas fa-plus"></i>
            </span>
              추가
            </button>

            <button class="btn-size btn-gray fl_left" @click="deleteItem">
              <span class="btn-icon">
                  <i class="fas fa-save"></i>
              </span>
              삭제
            </button>
          </div>
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :stopEditingWhenCellsLoseFocus="true"
                @grid-ready="onReadyMain"/>
          </div>
        </div>
      </div>

      <div class="table-b" style="width: 50%;">
        <el-form size="mini" :model="form" ref="catInfoForm" class="components">
          <el-row>
            <el-col>
              <el-col :span="12">
                <el-form-item label="영업부서">
                  <el-input v-model="form.saleDeptNm"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="영업담당">
                  <el-input v-model="form.saleChargeNm"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-col :span="12">
                <el-form-item label="설치비(1)">
                  <el-input v-model="form.setupUnitPrice1" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="설치비(2)">
                  <el-input v-model="form.setupUnitPrice2"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-col :span="12">
                <el-form-item label="출장급지">
                  <el-input v-model="form.setupEtcPrice1"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="기타비용">
                  <el-input v-model="form.setupEtcPrice2"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="총합계">
                <el-input v-model="form.setupAmt" disabled style="text-align: end;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-col :span="8">
                <el-form-item label="지역/센터">
                  <el-select v-model="form.catId" @change="onCatIdChange">
                    <el-option value=''  label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['catId']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="지역/센터 상세">
                  <el-select v-model="form.subCatId" placeholder="지역/센터 상세" @change="getSubCatIdChange">
                    <el-option value="" label="전체">전체</el-option>
                    <el-option
                        v-for="(item, idx) in combos['subCatId']"
                        :key="idx"
                        :value="parseInt(item.key)"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>

</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import DatepickerCellRenderer2 from '@/components/elementUI/datepicker-cell-renderer';
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import SelectCellRendererSecondary from "@/components/agGrid/select-cell-renderer-secondary";
import mixin from "@/mixin/lucoms";
import SiteSelectModal from "@/components/LucomsModal/SiteSelectModal";
import ModelInfoModal from "@/components/LucomsModal/ModelInfoModal";
// import ReqMateEnterModal from "@/components/LucomsModal/ReqMateEnterModal";
import AgGridSearchBtn from "@/components/agGrid/AgGridSearchBtn";
import _ from "lodash";

function comma(val){
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default {
  name: "productInstallEditInfo",
  mixins: [mixin],
  props: ['productInstallEditDetail'],
  data() {
    return {
      data: [],
      delData: [],
      gridStyle : 'padding-top: 40px; width: 100%;height: 200px; min-height:100px;',
      columnDefs: [],
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      defaultColDef: {
        resizable: true
        , filter:false
        , sortable: true
      },
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        datePicker2: DatepickerCellRenderer2,
        maskEdit: MaskEditCellRenderer,
        selectCellRenderer: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        schBtn : AgGridSearchBtn,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer,
        secondarySelect: SelectCellRendererSecondary,
      },
      /** modelSetupSelItem **/

      form: {
        companyId : '',
        requestId : '',
        requestDt : this.$moment().format('YYYY-MM-DD'),          // 의뢰일자
        requestNm : this.$store.state.loginInfo.userName,          // 의뢰자
        requestSetupDt : this.$moment().format('YYYY-MM-DD'),     /**설치완료요청일**/
        siteId : '',
        siteType : '',           // 고객구분
        siteNm1 : '',            // 사이트명1
        siteNm2 : '',            // 사이트명2
        siteNm3 : '',            // 사이트명3
        siteTypeNm: '',
        chargeNm : '',           // 고객명
        telNo : '',              // 전화번호
        hpNo : '',               // 휴대폰
        zipCd : '',
        addr1 : '',              // 주소1
        addr2 : '',              // 주소2
        memo : '',               // 특기사항
        saleDeptNm : '',
        saleChargeNm : '',
        setupUnitPrice1 : '',
        setupUnitPrice2 : '',
        setupEtcPrice1 : '',
        setupEtcPrice2 : '',
        setupDt : '',
        setupAmt : '',
        procYn : '',
        confirmDt : '',
        confirmYn : '',
        squareYymm : '',
        squareSetupUnitPrice1 : '',
        squareSetupUnitPrice2 : '',
        squareSetupEtcPrice1 : '',
        squareSetupEtcPrice2 : '',
        squareSetupAmt : '',
        squareYn : '',
        asAgentId : '',          // 처리기사
        asAgentNm : '',
        setupResult : '',
        deleteYn : '',
        creatorId : '',
        creatorNm : '',
        createDt : '',
        updatorId : '',
        updatorNm : '',
        updateDt : '',

        siteTypeCombo : '',
        yearsCombo : '',
        monthsCombo : '',


        /** info **/
        modelSetupInfoId : '',
        modelGroup: '',          /** 모델그룹 */
        modelGroupNm: '',        /** 모델그룹명 */
        modelId: '',             /** 모델ID */
        modelCd : '',
        modelNm : '',            // 모델명
        maker: '',               /** 제조사 */
        makerNm: '',             /** 제조사명 */
        guaranteeStartDt : '',
        guaranteeEndDt : '',
        purchaseDt : '',
        prodDt : '',
        modelQty : '',           // 의뢰대수
        guaranteeMonth : '',
        areaId : "",
        areaKey : "",
        areaNm : "",
      },
      defForm: {
        companyId : '',
        requestId : '',
        requestDt : this.$moment().format('YYYY-MM-DD'),          // 의뢰일자
        requestNm : this.$store.state.loginInfo.userName,          // 의뢰자
        requestSetupDt : this.$moment().format('YYYY-MM-DD'),     /**설치완료요청일**/
        siteId : '',
        siteType : '',           // 고객구분
        siteNm1 : '',            // 사이트명1
        siteNm2 : '',            // 사이트명2
        siteNm3 : '',            // 사이트명3
        chargeNm : '',           // 고객명
        telNo : '',              // 전화번호
        hpNo : '',               // 휴대폰
        zipCd : '',
        addr1 : '',              // 주소1
        addr2 : '',              // 주소2
        memo : '',               // 특기사항
        saleDeptNm : '',
        saleChargeNm : '',
        setupUnitPrice1 : '',
        setupUnitPrice2 : '',
        setupEtcPrice1 : '',
        setupEtcPrice2 : '',
        setupDt : '',
        setupAmt : '',
        procYn : '',
        confirmDt : '',
        confirmYn : '',
        squareYymm : '',
        squareSetupUnitPrice1 : '',
        squareSetupUnitPrice2 : '',
        squareSetupEtcPrice1 : '',
        squareSetupEtcPrice2 : '',
        squareSetupAmt : '',
        squareYn : '',
        asAgentId : '',          // 처리기사
        asAgentNm : '',
        setupResult : '',
        deleteYn : '',
        creatorId : '',
        creatorNm : '',
        createDt : '',
        updatorId : '',
        updatorNm : '',
        updateDt : '',

        siteTypeCombo : '',
        yearsCombo : '',
        monthsCombo : '',


        /** info **/
        modelSetupInfoId : '',
        modelGroup: '',          /** 모델그룹 */
        modelGroupNm: '',        /** 모델그룹명 */
        modelId: '',             /** 모델ID */
        modelCd : '',
        modelNm : '',            // 모델명
        maker: '',               /** 제조사 */
        makerNm: '',             /** 제조사명 */
        guaranteeStartDt : '',
        guaranteeEndDt : '',
        purchaseDt : '',
        prodDt : '',
        modelQty : '',           // 의뢰대수
        guaranteeMonth : '',
        areaId : "",
        areaKey : "",
        areaNm : "",
        subCatId: '',
      },
      // eslint-disable-next-line vue/no-dupe-keys
      tapName: "default",
      combos: {
        'catId' : [],
        'subCatId' : [],
        'procType' : [],
        'asAgentId' : [],
        'FRGN_CUR_CD' : [],
        'years' : [],
        'months' : [],
      },
    };
  },
  methods: {
    setProductInstallEditInfo() {
      Object.assign(this.form, this.productInstallEditDetail.modelSetupSelItem[0]);
      this.data = this.productInstallEditDetail.modelSetupSelInfo.map((item) => {
        item.purchaseDt = this.$moment(item.purchaseDt).format('YYYY-MM-DD');
        return item;
      });
      // 처리기사, 지역센터 값 세팅
      this.setCatIdAndSubCatId(this.form.asAgentId);
      this.combos["years"] = this.form.yearsCombo;
      this.changeData();
    },
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;
      //this.getGuaranteeMonth();
      this.init();
    },
    async init() {
      this.form.requestDt = this.$moment().format('YYYY-MM-DD') /** 당일 */
      this.form.requestProcDt = this.$moment().format('YYYY-MM-DD') /** 당일 */

      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/productInstallEdit/init`,{
        parentId: this.form.areaId
      })
          .then(response => {
            this.combos['years'] = response.data.years;
            this.combos['months'] = response.data.months;
            this.combos['catId'] = response.data.catId || [] ;
            this.combos['subCatId'] = response.data.subCatId || [] ;     //지역구분 상세
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });
      this.createMainColumnDefs();
    },
    createMainColumnDefs() {
      const vm = this;

      this.columnDefs = [
        {
          headerName:'선택',
          field:'chk',
          width:80,
          cellStyle:{textAlign: 'center'},
          cellRenderer: 'checkBox',
          ellRendererParams: {
            trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
            , disable: true
          },
        },
        {
          headerName:'No',
          field:'순위',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'모델명', field:'modelNm', width:120, editable : false},
        {headerName:'보증시작일', field:'guaranteeStartDt', width:120, editable : true, headerClass: 'require-column',
          cellRenderer: 'datePicker',
          cellStyle: (params) => {
            const idx = params.rowIndex;
            if(idx === this.selProcIdx){
              return {textAlign: 'center', backgroundColor: '#D5E6A3'};
            } else {
              return {textAlign: 'center'};
            }
          },
          valueFormatter: (params) => {
            return params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }
        },
        {headerName:'보증종료일', field:'guaranteeEndDt', width:120, editable : true, headerClass: 'require-column',
          cellRenderer: 'datePicker',
          cellStyle: (params) => {
            const idx = params.rowIndex;
            if(idx === this.selProcIdx){
              return {textAlign: 'center', backgroundColor: '#D5E6A3'};
            } else {
              return {textAlign: 'center'};
            }
          },
          valueFormatter: (params) => {
            return params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }
        },
        {
          headerName:'구입년월',
          field:'purchaseDt',
          width:130,
          headerClass: 'require-column',
          cellStyle:{textAlign: 'center'},
          cellRenderer: 'datePicker2',
          cellRendererParams: {
            // 참고 문서 : https://element.eleme.io/#/en-US/component/date-picker#attributes
            type: 'month',
            format: 'yyyy-MM',  //date format
            valueFormat: 'yyyy-MM-dd',  //받는 model 의 결과 포맷
            disable: false, //disabled 처리
          },
          valueFormatter: (params) => {
            return params.value === null  ? '' : this.$moment(params.value).format('yyyy-MM-dd') ;
          }
        },
        {headerName:'수량', field:'modelQty', width:120, cellStyle:{textAlign: 'right', backgroundColor: '#fff8f7'}, editable : true, headerClass: 'require-column',
          valueFormatter: (params) => {
            return vm.getNumberFormat(params.value);
          }
        },
      ];
    },
    defaultInfo(){
      this.tapName = "default";
    },
    agentInfo(){
      this.tapName = "agent";
    },
    timeTableInfo(){
      this.tapName = "time";
    },
    deleteButton(){

    },
    saveButton(){

    },
    /**
     * 사용 회수 자재 팝업 오픈
     * *
     */
    openModel() {
      let vm = this;
      this.$modal.open({
        width: 800,
        component: ModelInfoModal,
        parent: this,
        props: {
          data: {
            modelNm : vm.form.modelNm
          }
        },
        events: {
          close(param) {
            vm.data.push({
              companyId : param.data.companyId,
              createDt : param.data.createDt,
              creatorId : param.data.creatorId,
              creatorNm : param.data.creatorNm,
              guaranteeMonth : param.data.guaranteeMonth,
              guaranteeStartDt : '',
              guaranteeEndDt : '',
              purchaseDt : '',
              maker : param.data.maker,
              makerNm : param.data.makerNm,
              modelCd : param.data.modelCd,
              modelGroup : param.data.modelGroup,
              modelGroupNm : param.data.modelGroupNm,
              modelId : param.data.modelId,
              modelNm : param.data.modelNm,
              standardModelNm : param.data.standardModelNm,
              updateDt : param.data.updateDt,
              updatorId : param.data.updatorId,
              updatorNm : param.data.updatorNm
            });
          },
        }
      });
    },
    cancle(){
      this.form = _.clone(this.defForm);
      this.data = [];
    },
    deleteItem() {

      var list = this.data.filter(v => v.chk === 'Y')

      if(list.length == 0){
        this.$swal({ type: 'warning', text: '삭제할 모델을 선택해 주십시요.'});
        return false;
      }

      const vm = this
      const vData = vm.data.filter(v => v.chk !== 'Y')
      this.delData = vm.data.filter(v => v.chk === 'Y')

      vm.data = JSON.parse(JSON.stringify(vData))
    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    getCombo() {
      this.getCatIdCombo();
      this.getProcType();
    },
    getProcType(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 247} })
          .then(response => {
            this.combos['procType'] = response.data || []
          });
    },
    // getConfigValue() {
    //   this.$http.get(`/api/config/keyPath/info`, {params: {keyPath: 'System.MainAsAgentId'}})
    //       .then(response => {
    //         this.form.asAgentId = response.data[0].configValue;
    //       });
    // },
    getCatIdCombo(){
      this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: 217} })
          .then(response => {
            // this.combos['catId'] = response.data || []
          });
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      this.combos['catId'].forEach(x=>{
        if(x.key == param) {
          this.form.areaId = x.id;
          this.form.areaKey = x.key;
        }
      })
      this.init();
      this.$forceUpdate();


    },
    getSubCatIdChange(param){
      // this.form.asAgentId = null;
      this.$forceUpdate();
    },
    //  그리드 데이터 선택 후 지역/센터 값 세팅
    setCatIdAndSubCatId(param){

      let valueSubCatId;
      this.$http.get(`/api/codeMng/detail`, { params: {catKey: param}})
          .then(response => {
            // 조회 한 지역/센터 값
            valueSubCatId = response.data.map(x => {
              x.key = x.parentId
              x.value = x.parentNm
              return x
            })
            // // 지역 값 선택
            this.form.catId  = this.combos['catId'].filter(x => parseInt(x.id) === valueSubCatId[0].key)[0].key
            this.form.areaId  = this.combos['catId'].filter(x => parseInt(x.id) === valueSubCatId[0].key)[0].id
            // // 지역 상세값 리스트 조회
            this.$http.get(`/api/codeMng/combo`, { params: {parentId: valueSubCatId[0].parentId} })
                .then(response => {
                  this.combos['subCatId'] = response.data || []
                  this.form.subCatId  = parseInt(this.combos['subCatId'].filter(x => x.key === valueSubCatId[0].catKey)[0].key);
                  this.$forceUpdate();
                })
          })
    },
    dataClear(){
      this.form.companyId = ''
      this.form.requestId = ''          // 의뢰번호
      this.form.requestDt = ''          // 의뢰일자
      this.form.requestNm = ''          // 의뢰자
      this.form.siteType = ''           // 고객구분
      this.form.siteTypeNm = ''         // 고객구분명
      this.form.addr1 = ''              // 주소1
      this.form.addr2 = ''              // 주소2
      this.form.chargeNm = ''           // 고객명
      this.form.telNo = ''              // 전화번호
      this.form.hpNo = ''               // 휴대폰
      this.form.modelNm = ''            // 모델
      this.form.modelQty = ''           // 의뢰대수
      this.form.requestProcDt = ''      // 처리요청일
      this.form.workDetails = ''        // 작업내용
      this.form.memo = ''               // 특기사항
      this.form.procUnitPrice1 = ''     // 처리비
      this.form.procUnitPrice2 = ''     // 단가
      this.form.procEtcPrice1 = ''      // 출장급지
      this.form.procEtcPrice2 = ''      // 기타비용
      this.form.catId = ''              // 지역
      this.form.subCatId = ''           // 지역상세
      this.form.sortType = ''           // 승인/정산처리유형
      this.form.siteNm1 = ''            // 사이트명1
      this.form.siteNm2 = ''            // 사이트명2
      this.form.siteNm3 = ''            // 사이트명3
    },
    // searchModel(){
    //   /** 모델선택 */
    //   let vm = this;
    //   this.$modal.open({
    //     width: 800,
    //     component: ModelSelectModal,
    //     parent: this,
    //     props: {
    //       data: {
    //       },
    //     },
    //     events: {
    //       close(param) {
    //         vm.form.maker = param.data.maker /** 제조사 */
    //         vm.form.makerNm = param.data.makerNm /** 제조사명 */
    //         vm.form.modelGroupNm = param.data.modelGroupNm /** 모델그룹명 */
    //         vm.form.modelGroup = param.data.modelGroup /** 모델그룹 */
    //         vm.form.standardModelNm = param.data.standardModelNm /** 표준모델 */
    //         vm.form.modelNm = param.data.modelNm /** 모델명 */
    //         vm.form.modelId = param.data.modelId /** 모델ID */
    //       },
    //     }
    //   });
    // },
    searchSite(){
      /** 사이트선택(고객구분) */
      let vm = this;
      this.$modal.open({
        width: 800,
        component: SiteSelectModal,
        parent: this,
        props: {
          data: {
          },
        },
        events: {
          close(param) {
            vm.form.siteNm1 = param.data.siteNm1          // 사이트명1
            vm.form.siteNm2 = param.data.siteNm2          // 사이트명2
            vm.form.siteNm3 = param.data.siteNm3          // 사이트명3
            vm.form.addr1 = param.data.addr1              // 주소1
            vm.form.addr2 = param.data.addr2              // 주소2
            vm.form.chargeNm = param.data.chargeNm        // 고객명
            vm.form.telNo = param.data.telNo              // 전화번호
            vm.form.hpNo = param.data.hpNo                // 핸드폰
            vm.form.siteType = param.data.siteType        // 고객구분
            vm.form.siteTypeNm = param.data.siteTypeNm    // 고객구분
            vm.form.zipCd = param.data.zipCd              // 주소
            vm.form.siteId = param.data.siteId            // 사이트 ID

            vm.form.catId = param.data.area;
            vm.form.subCatId = param.data.asAgentId;
            vm.chekcVal(vm.form.catId);
          },
        }
      });
    },
    chekcVal(val) {
      if(val) {
        this.combos['catId'].forEach(x=>{
          if(x.key == val) {
            this.form.areaId = x.id;
            this.form.areaKey = x.key;
          }
        })
      }
      this.init();
    },
    changeData(){
      //고객구분 코드 => 코드명 변경
      let filterSiteType = this.form.siteTypeCombo.filter(x => x.key === this.form.siteType);
      this.form.siteTypeNm = filterSiteType[0].value;

      this.form.setupUnitPrice1 = comma(this.form.setupUnitPrice1);  // 설치비(1)
      this.form.setupUnitPrice2 = comma(this.form.setupUnitPrice2);  // 설치비(2)
      this.form.setupEtcPrice1 = comma(this.form.setupEtcPrice1);    // 출장급지
      this.form.setupEtcPrice2 = comma(this.form.setupEtcPrice2);    // 기타비용
      this.form.setupAmt = comma(this.form.setupAmt);          // 총합계
    },
    // updateRealItem(pVal){

    //   const that = this;
    //   const rowNode = this.mainGridOptions.api.getRowNode(this.rowId);

    //   this.$modal.open({
    //     component: ReqMateEnterModal,
    //     parent: this,
    //     width: 700,
    //     props: {
    //       data: {
    //         modelNm : that.form.modelNm
    //       }
    //     },
    //     events: {
    //       close(object) {
    //         rowNode.setDataValue('recallItemCd', object.itemCd);
    //         rowNode.setDataValue('recallItemNm', object.itemNm);
    //         that.data[that.rowId].recallItemCd = object.itemCd;
    //         that.data[that.rowId].recallItemNm = object.itemNm;
    //       }
    //     }
    //   });
    // },
  },
  mounted() {
    this.getCombo()
//    this.getConfigValue()
  },
  watch: {
    productInstallEditDetail() {
      this.setProductInstallEditInfo();
    },
    'form.asAgentId'(){
      this.form.subCatId = this.form.asAgentId;
    },
    'form.catId'(val) {
      
      if(val) {
        this.combos['catId'].forEach(x=>{
          if(x.key == val) {
            this.form.areaId = x.id;
            this.form.areaKey = x.key;
          }
        })
      }
      this.init();
    },
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}
.el-select {
  width: 100%;
}
</style>